module.exports = __webpack_public_path__ + "static/media/documentation_portal.ffcfaaae.png";